/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcIncreaseV1AccountNumberState } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_INCREASE_V1_ACCOUNT_NUMBER_STATE_ENTITY_NAME = 'exc.increase.v1.AccountNumber';
export const excIncreaseV1AccountNumberStateEntity = new schema.Entity<ExcIncreaseV1AccountNumberState>(EXC_INCREASE_V1_ACCOUNT_NUMBER_STATE_ENTITY_NAME, {}, { idAttribute: 'accountNumberId' });

